import {get} from '../common'
import {store} from '../../redux/store';

export const getAuthToken = () => {
    const auth = store.getState().auth;
    const tempAuth = store.getState().tempAuth;
    return get(tempAuth.user, 'bearerToken', false) || get(auth.user, 'bearerToken', false);
};
